import formComponent from '@/util/proto/formComponent'
import { phoneValidator , idNumberValidator } from '@/util/validator'

export default {
  extends: formComponent,
  data() {
    return {
      formData: {
        supplierName: {
          rules: [
            { required: true, message: '请输入供应商名称', trigger: 'blur,change' },
          ]
        },
        contacts: {
          rules: [
            { required: true, message: '请输入联系人', trigger: 'blur,change' },
          ],
        },
        contactsPhone: {
          rules: [
            { required: true, trigger: 'blur,change' ,validator: phoneValidator('请输入联系人电话', '请输入正确格式')},
          ],
        },
        legalPersonPhone: {
          rules: [
            { required: true, trigger: 'blur,change' ,validator: phoneValidator('请输入法人电话', '请输入正确格式')},
          ],
        },
        unionCreditCode:{
          rules: [
            { required: true, message: '请输入统一信用代码', trigger: 'blur,change' },
          ],
        },
        registeredCapital:null,
        supplierNature:null,
        legalPerson:null,
        registeredAddress:null,
        officeSpace:null,
        remark:null
      },
      def: {},
      
      id: null,
      loading: false,
      visible: false,
      api:['assSupplierCreate','assSupplierUpdate']
    }
  },

  created() {

  },
  computed: {
    itemTitle() {
      return this.id ? '编辑供应商' : '新增供应商'
    }
  },

  methods: {
    init(id) {
      this.id = id
      this.reset()
      this.visible = true
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.loading = true
      this.$request.assSupplier(this.id).then(resp => {
        this.loading = false
        this.$setFormData(resp.data)
      })
    },
    reset() {
      this.$resetFormData()
    },

    beforeSave(d){
      if(this.id) d.id = this.id
      return d
    }

  },

  render(){
    return  <sl-side-panel v-model={this.visible} loading={this.loading} mask-closable={false} title={this.itemTitle} loading={this.loading}>
        <sl-form label-width={110}>
          <sl-form-item label="供应商名称">
            <Input v-decorator={this.formData.supplierName} maxlength={128}></Input>
          </sl-form-item>
          <sl-form-item label="统一信用代码">
            <Input v-decorator={this.formData.unionCreditCode} maxlength={64}></Input>
          </sl-form-item>
          <sl-form-item label="注册资本">
            <Input v-decorator={this.formData.registeredCapital} maxlength={64}></Input>
          </sl-form-item>
          <sl-form-item label="企业性质">
            <sl-select v-decorator={this.formData.supplierNature} dict="companyNature"></sl-select>
          </sl-form-item>
          <sl-form-item label="法人">
            <Input v-decorator={this.formData.legalPerson} maxlength={32}></Input>
          </sl-form-item>
          <sl-form-item label="法人电话">
            <Input v-decorator={this.formData.legalPersonPhone} maxlength={16}></Input>
          </sl-form-item>
          <sl-form-item label="联系人">
            <Input v-decorator={this.formData.contacts} maxlength={32}></Input>
          </sl-form-item>
          <sl-form-item label="联系电话">
            <Input v-decorator={this.formData.contactsPhone} maxlength={16}></Input>
          </sl-form-item>
          <sl-form-item label="注册地址">
            <Input v-decorator={this.formData.registeredAddress}></Input>
          </sl-form-item>
          <sl-form-item label="办公地点">
            <Input v-decorator={this.formData.officeSpace}></Input>
          </sl-form-item>
          <sl-form-item label="备注">
            <Input type="textarea" autosize={{minRows: 5,maxRows: 8}} v-decorator={this.formData.remark}></Input>
          </sl-form-item>
        </sl-form>

        <div slot="footer">
          <Button loading={this.loading} on-click={this.$handleSubmit} type="primary">确定</Button>
        </div>
    </sl-side-panel>
  }
}

